(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-entry-gate"]) return;
  try {
    
  (function () {
    function containsAny(value, parts) {
      for (var index = 0; index < parts.length; index += 1) {
        if (value.indexOf(parts[index]) !== -1) return true;
      }
      return false;
    }

    function updateEntryGate(gate) {
      if (gate.dataset.designMode === 'true') {
        gate.hidden = true;
        return;
      }

      var userAgent = (navigator.userAgent || '').toLowerCase();
      var vendor = (navigator.vendor || '').toLowerCase();
      var signature = userAgent + ' ' + vendor;
      var parameters = new URLSearchParams(window.location.search);
      var cameFromTikTok = parameters.get('source') === 'tiktok';
      var hasTikTokSignature = containsAny(signature, [
        'tiktok',
        'musical_ly',
        'musically',
        'bytedance',
        'ttwebview',
        'aweme',
        'trill'
      ]);
      var isIOS = containsAny(userAgent, ['iphone', 'ipad', 'ipod']);
      var isAndroid = userAgent.indexOf('android') !== -1;
      var isIOSBrowser = isIOS && containsAny(userAgent, [
        'safari/',
        'crios/',
        'fxios/',
        'edgios/',
        'opios/',
        'duckduckgo/'
      ]);
      var isAndroidWebView = containsAny(userAgent, ['; wv)', ' wv', 'version/4.0']);
      var isAndroidBrowser = isAndroid && containsAny(userAgent, [
        'chrome/',
        'firefox/',
        'edga/',
        'samsungbrowser/',
        'opr/'
      ]) && !isAndroidWebView;
      var isDesktopBrowser = !isIOS && !isAndroid;
      var isExternalBrowser = !hasTikTokSignature && (
        isIOSBrowser || isAndroidBrowser || isDesktopBrowser
      );
      var showGate = hasTikTokSignature || (cameFromTikTok && !isExternalBrowser);

      gate.hidden = !showGate;
      document.documentElement.classList.toggle('sb-tiktok-entry-active', showGate);
    }

    function updateAllEntryGates() {
      var gates = document.querySelectorAll('[data-tiktok-entry-gate]');
      for (var index = 0; index < gates.length; index += 1) {
        updateEntryGate(gates[index]);
      }
    }

    updateAllEntryGates();
    window.addEventListener('pageshow', updateAllEntryGates);
  })();

  } catch(e) { console.error(e); }
})();
})();
